import React from 'react';
import { BuildingIcon, UsersIcon, TrendingUpIcon, ActivityIcon, DollarSignIcon, FileTextIcon } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const AdminDashboard = () => {
  const platformStats = [{
    title: 'Empresas activas',
    value: '24',
    change: '+3 este mes',
    icon: <BuildingIcon size={24} data-id="element-344" />,
    color: 'blue'
  }, {
    title: 'Usuarios totales',
    value: '156',
    change: '+12 este mes',
    icon: <UsersIcon size={24} data-id="element-345" />,
    color: 'purple'
  }, {
    title: 'Reportes generados',
    value: '1,247',
    change: '+89 esta semana',
    icon: <FileTextIcon size={24} data-id="element-346" />,
    color: 'green'
  }, {
    title: 'Ingresos MRR',
    value: '$48,500',
    change: '+8.2% vs mes anterior',
    icon: <DollarSignIcon size={24} data-id="element-347" />,
    color: 'orange'
  }];
  const activityData = [{
    month: 'Ene',
    companies: 18,
    users: 98
  }, {
    month: 'Feb',
    companies: 19,
    users: 112
  }, {
    month: 'Mar',
    companies: 20,
    users: 125
  }, {
    month: 'Abr',
    companies: 21,
    users: 134
  }, {
    month: 'May',
    companies: 22,
    users: 144
  }, {
    month: 'Jun',
    companies: 24,
    users: 156
  }];
  const revenueData = [{
    month: 'Ene',
    revenue: 38000
  }, {
    month: 'Feb',
    revenue: 41000
  }, {
    month: 'Mar',
    revenue: 43500
  }, {
    month: 'Abr',
    revenue: 45000
  }, {
    month: 'May',
    revenue: 46500
  }, {
    month: 'Jun',
    revenue: 48500
  }];
  const recentActivity = [{
    id: 1,
    type: 'company',
    action: 'Nueva empresa registrada',
    details: 'Services Plus - Servicios',
    timestamp: 'Hace 2 horas'
  }, {
    id: 2,
    type: 'user',
    action: 'Nuevo usuario agregado',
    details: 'Carlos Méndez - Retail Express',
    timestamp: 'Hace 5 horas'
  }, {
    id: 3,
    type: 'data',
    action: 'Datos financieros actualizados',
    details: 'PYME Solutions - Julio 2023',
    timestamp: 'Hace 1 día'
  }, {
    id: 4,
    type: 'report',
    action: 'Reporte descargado',
    details: 'Manufacturing Pro - Estado de Resultados',
    timestamp: 'Hace 1 día'
  }];
  const getStatColor = (color: string) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600',
      purple: 'bg-purple-100 text-purple-600',
      green: 'bg-green-100 text-green-600',
      orange: 'bg-orange-100 text-orange-600'
    };
    return colors[color as keyof typeof colors];
  };
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'company':
        return <BuildingIcon size={16} className="text-blue-600" data-id="element-348" />;
      case 'user':
        return <UsersIcon size={16} className="text-purple-600" data-id="element-349" />;
      case 'data':
        return <TrendingUpIcon size={16} className="text-green-600" data-id="element-350" />;
      case 'report':
        return <FileTextIcon size={16} className="text-orange-600" data-id="element-351" />;
      default:
        return <ActivityIcon size={16} className="text-gray-600" data-id="element-352" />;
    }
  };
  return <div data-id="element-353">
      <div className="mb-6" data-id="element-354">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-355">
          Panel de Administración
        </h1>
        <p className="text-gray-600" data-id="element-356">
          Vista general de la plataforma FinancePro
        </p>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-357">
        {platformStats.map((stat, index) => <div key={index} className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-358">
            <div className="flex items-start justify-between mb-3" data-id="element-359">
              <div className={`w-12 h-12 rounded-lg ${getStatColor(stat.color)} flex items-center justify-center`} data-id="element-360">
                {stat.icon}
              </div>
            </div>
            <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-361">
              {stat.title}
            </h3>
            <p className="text-2xl font-bold text-gray-900 mb-1" data-id="element-362">
              {stat.value}
            </p>
            <p className="text-xs text-gray-500" data-id="element-363">{stat.change}</p>
          </div>)}
      </div>
      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-364">
        {/* Growth Chart */}
        <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-365">
          <h2 className="text-lg font-semibold mb-4" data-id="element-366">
            Crecimiento de la plataforma
          </h2>
          <div className="h-64" data-id="element-367">
            <ResponsiveContainer width="100%" height="100%" data-id="element-368">
              <LineChart data={activityData} data-id="element-369">
                <CartesianGrid strokeDasharray="3 3" data-id="element-370" />
                <XAxis dataKey="month" data-id="element-371" />
                <YAxis data-id="element-372" />
                <Tooltip data-id="element-373" />
                <Line type="monotone" dataKey="companies" name="Empresas" stroke="#3B82F6" strokeWidth={2} data-id="element-374" />
                <Line type="monotone" dataKey="users" name="Usuarios" stroke="#8B5CF6" strokeWidth={2} data-id="element-375" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        {/* Revenue Chart */}
        <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-376">
          <h2 className="text-lg font-semibold mb-4" data-id="element-377">Ingresos mensuales</h2>
          <div className="h-64" data-id="element-378">
            <ResponsiveContainer width="100%" height="100%" data-id="element-379">
              <BarChart data={revenueData} data-id="element-380">
                <CartesianGrid strokeDasharray="3 3" data-id="element-381" />
                <XAxis dataKey="month" data-id="element-382" />
                <YAxis tickFormatter={value => `$${value / 1000}K`} data-id="element-383" />
                <Tooltip formatter={value => [`$${value.toLocaleString()}`, 'MRR']} data-id="element-384" />
                <Bar dataKey="revenue" fill="#10B981" radius={[4, 4, 0, 0]} data-id="element-385" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      {/* Recent Activity */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-386">
        <h2 className="text-lg font-semibold mb-4" data-id="element-387">Actividad reciente</h2>
        <div className="space-y-3" data-id="element-388">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-389">
              <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-390">
                {getActivityIcon(activity.type)}
              </div>
              <div className="flex-1 min-w-0" data-id="element-391">
                <p className="text-sm font-medium text-gray-900" data-id="element-392">
                  {activity.action}
                </p>
                <p className="text-sm text-gray-500" data-id="element-393">{activity.details}</p>
              </div>
              <span className="text-xs text-gray-400 whitespace-nowrap" data-id="element-394">
                {activity.timestamp}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};
export default AdminDashboard;